import {
  Modal
} from 'UI'
import { useState } from 'react'
import { createUseStyles } from 'react-jss'
import ConfirmationStep from './ConfirmationStep'
import PaymentStep from './PaymentStep'
import style from './style'

export const paymentStep = 1
export const confirmationStep = 2

const modalCore = ({ step, setStep, setOpen }) => {
  switch (step) {
    case paymentStep:
      return <PaymentStep setStep={setStep} />
    case confirmationStep:
      return <ConfirmationStep setStep={setStep} setOpen={setOpen} />
    default:
      return null
  }
}
const useStyles = createUseStyles(style)

export default ({ open, setOpen }) => {
  const [step, setStep] = useState(paymentStep)
  const { modal } = useStyles()
  return (
    <Modal
      handleClose={() => setOpen(false)}
      isOpen={open}
      className={modal}
      align='baseline'
    >
      {modalCore({ step, setStep, setOpen })}
    </Modal>
  )
}
